function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h184v100H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.342 7.097c-7.86.01-12.37 9.904-13.014 11.047-1.4 2.484-4.113 4.69-6.185 2.218-.95-1.134-.106-3.23.631-4.429 1.245-2.024-.412-4.558-2.753-4.243-11.453 1.542-24.563 13.647-21.899 29.083 1.397 8.09 11.09 18.234 27.163 10.629 10.723-5.603 12.133-16.3 14.285-28.827.969-5.637 3.543-8.249 6.08-9.416 2.189-1.006 2.252-4.128.046-5.095-1.535-.673-2.976-.964-4.32-.967h-.034z",
  id: "f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.132 1.18C37.751-.86 51.015-.32 64.495 3.299c13.266 3.56 24.863 9.595 33.848 17.014 4.21 7.407 6.615 15.974 6.615 25.104 0 22.349-14.412 41.331-34.45 48.161-9.254.535-19.229-.448-29.326-3.157-12.145-3.26-22.892-8.593-31.515-15.165A50.64 50.64 0 0 1 0 45.415C0 26.542 10.28 10.068 25.546 1.288z",
  id: "h"
}), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "80.076%",
  y1: "12.968%",
  x2: "50%",
  y2: "113.829%",
  id: "e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBD6A3",
  offset: "68.388%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF4E5",
  offset: "99.978%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "68.852%",
  y1: "20.009%",
  x2: "95.246%",
  y2: "68.031%",
  id: "i"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFECD1",
  offset: "68.388%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF4E5",
  offset: "99.978%"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-14.1%",
  y: "-14.9%",
  width: "128.3%",
  height: "129.8%",
  filterUnits: "objectBoundingBox",
  id: "g"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
  in: "shadowInnerInner1"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-8.1%",
  y: "-9.1%",
  width: "116.2%",
  height: "118.1%",
  filterUnits: "objectBoundingBox",
  id: "j"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -7,
  dy: 4,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
  in: "shadowInnerInner1"
})), /*#__PURE__*/React.createElement("ellipse", {
  id: "c",
  cx: 54.03,
  cy: 51.372,
  rx: 44.935,
  ry: 41.125
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 178.012 -4)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.346)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFC663",
  transform: "rotate(15 54.03 51.372)",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#31A496",
  mask: "url(#d)",
  transform: "rotate(15 52.538 56.948)",
  cx: 52.538,
  cy: 56.948,
  rx: 55,
  ry: 35.353
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#e)",
  xlinkHref: "#f"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#g)",
  xlinkHref: "#f"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFC663",
  transform: "rotate(15 101.18 60.015)",
  cx: 101.18,
  cy: 60.015,
  rx: 71.896,
  ry: 32.467
}), /*#__PURE__*/React.createElement("g", {
  fill: "#463B3B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-.465 41.832a2.7 2.7 0 0 0-1.949 3.14l.04.167L1.46 59.455c2.365 8.826 11.352 14.11 20.174 11.923l.312-.08 3.762-1.008c8.818-2.363 14.089-11.357 11.9-20.188l-.08-.311-3.837-14.316a2.7 2.7 0 0 0-5.255 1.23l.04.167 3.835 14.316c1.596 5.957-1.85 12.073-7.72 13.806l-.28.08-3.763 1.008c-5.945 1.593-12.056-1.863-13.792-7.743l-.08-.282-3.836-14.316a2.7 2.7 0 0 0-3.306-1.91z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.644 37.317a2.7 2.7 0 0 0-1.949 3.14l.04.166 17.507 65.342a2.7 2.7 0 0 0 5.256-1.232l-.04-.166L17.95 39.226a2.7 2.7 0 0 0-3.306-1.91z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 137 33.828)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#i)",
  xlinkHref: "#h"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#j)",
  xlinkHref: "#h"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 106.422 54.296)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#000",
  x: 17.253,
  width: 4.673,
  height: 4.69,
  rx: 2.336
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#000",
  width: 4.673,
  height: 4.69,
  rx: 2.336
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.014 5.827c-3.973 0-7.193 3.246-7.193 7.25h14.386c0-4.004-3.22-7.25-7.193-7.25",
  fill: "#F4D100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.535 24.587c2.58 0 4.672-2.26 4.672-5.05H7.862c0 2.79 2.092 5.05 4.673 5.05",
  fill: "#F2A100"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B7650B",
  d: "M7.862 13.042h9.346v6.494H7.862z"
}))));

function SvgImgHomeFarmFinix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 100,
    viewBox: "0 0 184 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHomeFarmFinix);
export default __webpack_public_path__ + "static/media/img_home_farm_finix.b4d8a676.svg";
export { ForwardRef as ReactComponent };